const SearchIcon = ({ className = '' }) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.3-4.3" />
  </svg>
);

const GlossarySearchBar = ({ value, onChange, placeholder = 'Hledat pojem…' }) => {
  return (
    <div className="relative w-full">
      <SearchIcon className="text-grey-500 pointer-events-none absolute top-1/2 left-5 -translate-y-1/2" />
      <input
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        autoComplete="off"
        aria-label="Hledat pojem"
        className="border-grey-200 focus:border-brand-500 focus:ring-brand-500/10 w-full rounded-2xl border-[1.5px] bg-white py-4 pr-5 pl-13 text-base transition-all outline-none focus:ring-4"
      />
    </div>
  );
};

export default GlossarySearchBar;
